'use strict';

export function version() {
  return '0.1.1';
}

/**
 * Splits a block of text and wraps a span around both words and chars.
 *
 * @param text
 */
export function spanWrap(text) {
  const words = text.split(/\s+/);
  return words.map(word => {
    return `<span aria-hidden="true" class="word">${word.split('').map(letter => `<span aria-hidden="true" class="letter">${letter}</span>`).join('')}</span>`;
  }).join(' ');
}

/**
 * @param searchWords
 * @param el
 */
export function highlight(searchWords, el) {
  const originalText = el.textContent;
  let highlightedHTML = originalText;

  searchWords.forEach(searchWord => {
    const escapedWord = searchWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b(${escapedWord}\\w*)`, 'gi');

    highlightedHTML = highlightedHTML.replace(regex, '<mark class="search-highlight">$1</mark>');
  });

  if (highlightedHTML !== originalText) {
    el.innerHTML = highlightedHTML;
  }
}
